import { useCallback, useRef, useState } from 'react'
import { Box } from '@mui/material'
import PlayPauseButton from './PlayPauseButton'
import { BUTTON_TRANSITION } from '../../theme/buttonHover'
import { videoThumbnail } from '../../assets/index'

const DUMMY_VIDEO_SRC =
  'https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4'

export default function VideoSection({ poster = videoThumbnail, videoSrc = DUMMY_VIDEO_SRC }) {
  const videoRef = useRef(null)
  const [isPlaying, setIsPlaying] = useState(false)

  const togglePlayback = useCallback(async () => {
    const video = videoRef.current
    if (!video) return

    try {
      if (video.paused) {
        await video.play()
      } else {
        video.pause()
      }
    } catch {
      setIsPlaying(false)
    }
  }, [])

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        borderRadius: '20px',
        overflow: 'hidden',
        aspectRatio: { xs: '16 / 9', md: '1520 / 740' },
        bgcolor: '#000',
      }}
    >
      <Box
        component="video"
        ref={videoRef}
        src={videoSrc}
        poster={poster}
        playsInline
        preload="metadata"
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
        onEnded={() => setIsPlaying(false)}
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 22%',
          display: 'block',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />

      <Box
        role="button"
        tabIndex={0}
        aria-label={isPlaying ? 'Pause video' : 'Play video'}
        onClick={togglePlayback}
        onKeyDown={(event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            togglePlayback()
          }
        }}
        sx={{
          position: 'absolute',
          inset: 0,
          zIndex: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          bgcolor: isPlaying ? 'transparent' : 'rgba(0,0,0,0.4)',
          borderRadius: '20px',
          transition: BUTTON_TRANSITION,
          '&:hover': {
            bgcolor: isPlaying ? 'rgba(0,0,0,0.12)' : 'rgba(0,0,0,0.45)',
          },
        }}
      >
        <PlayPauseButton isPlaying={isPlaying} decorative sx={{ pointerEvents: 'none' }} />
      </Box>
    </Box>
  )
}
